import { useLocation } from 'react-router-dom'

const useUrlSearchParams = () => {
  const { search } = useLocation()
  return new URLSearchParams(search)
}

export default useUrlSearchParams
